import type { Chord } from 'svguitar';

export const FSustChords: Record<string, Chord> = {
  'F#': {
    fingers: [
      [3, 3, '2'],
      [4, 4, '4'],
      [5, 4, '3'],
    ],
    barres: [
      {
        fromString: 6,
        toString: 1,
        fret: 2,
        text: '1',
        color: '#0F0',
        textColor: '#F00',
      },
    ],
    title: 'F#',
    position: 0,
  },
  'F#m': {
    fingers: [
      [4, 4, '3'],
      [5, 4, '2'],
    ],
    barres: [
      {
        fromString: 6,
        toString: 1,
        fret: 2,
        text: '1',
        color: '#0F0',
        textColor: '#F00',
      },
    ],
    title: 'F#m',
    position: 0,
  },
  'F#m7': {
    fingers: [[5, 4, '2']],
    barres: [
      {
        fromString: 6,
        toString: 1,
        fret: 2,
        text: '1',
        color: '#0F0',
        textColor: '#F00',
      },
    ],
    title: 'F#m7',
    position: 0,
  },
};
